/* eslint-disable react/jsx-curly-newline */

import moment from 'moment';

import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { MdOutlineRefresh } from 'react-icons/md';

import Chart from 'react-apexcharts';

import Container from '~/components/container';

import ContainerFlex from '~/components/containerFlex';

import Dialog from '~/components/dialog';

import Loading from '~/components/loading';

import useApi, { ApiMethod } from '~/hooks/useApi';

import Endpoints from '~/services/endpoints';

import SelectDate from '~/components/selectDate';
import * as S from './styles';

export interface PushDashboardResponse {
  ano: number;

  dataVencimento?: string;
  dataCorte?: string;
  historicoDisparos: HistoricoDisparo[];

  mes: number;

  resumoDiaAtual: ResumoDiaAtual;
}

export interface HistoricoDisparo {
  completedAt?: string;

  createdAt: string;

  dataCorte: string;

  dataVencimento: string;

  dia: string;

  id: string;

  pushEnviadas: number;

  pushPendentes: number;

  status: string;

  title: string;

  topicName: string;

  topicType: string;

  totalClientes: number;
  description: string;
}

export interface ResumoDiaAtual {
  percentualEnviadas: number;

  pushEnviadas: number;

  pushPendentes: number;

  status: string;

  totalClientes: number;
}
type TopicsResponse = {
  id: string;
  name: string;
  title: string;
  type: string;
};
enum FormTypes {
  FECHAMENTO = 'FECHAMENTO',
  REGUA_COBRANCA = 'REGUA_COBRANCA',
  COMUNICACAO = 'COMUNICACAO',
}

const REPORT_PUSH_OPTIONS = [
  { value: 'Fechamento', id: FormTypes.FECHAMENTO },

  { value: 'Cobrança', id: FormTypes.REGUA_COBRANCA },

  { value: 'Comunicação', id: FormTypes.COMUNICACAO },
];

const MONTH_OPTIONS = [
  { id: '01', value: 'Janeiro' },

  { id: '02', value: 'Fevereiro' },

  { id: '03', value: 'Março' },

  { id: '04', value: 'Abril' },

  { id: '05', value: 'Maio' },

  { id: '06', value: 'Junho' },

  { id: '07', value: 'Julho' },

  { id: '08', value: 'Agosto' },

  { id: '09', value: 'Setembro' },

  { id: '10', value: 'Outubro' },

  { id: '11', value: 'Novembro' },

  { id: '12', value: 'Dezembro' },
];

const CLOSING_DAY_OPTIONS = [21, 25, 1, 4, 9, 14];

const DUE_DAY_OPTIONS = [1, 5, 10, 15, 20, 25];

const getYearOptions = () => {
  const currentYear = moment().year();

  const years = [];

  for (let year = 2019; year <= currentYear + 1; year += 1) {
    years.push({ id: String(year), value: String(year) });
  }

  return years;
};

const YEAR_OPTIONS = getYearOptions();

const numberFormatter = new Intl.NumberFormat('pt-BR');

interface FilterState {
  type: FormTypes;

  month: string;

  year: string;

  dueOrClosingDay: number;

  campaign: string;
}

const getInitialFilters = (): FilterState => ({
  type: FormTypes.FECHAMENTO,

  month: moment().format('MM'),

  year: moment().format('YYYY'),

  dueOrClosingDay: CLOSING_DAY_OPTIONS[0],

  campaign: '',
});

const getDefaultDueOrClosingDay = (type: FormTypes) => {
  if (type === FormTypes.REGUA_COBRANCA) {
    return DUE_DAY_OPTIONS[0];
  }

  return CLOSING_DAY_OPTIONS[0];
};

const formatNumber = (value?: number) =>
  value !== null && value !== undefined ? numberFormatter.format(value) : '0';

const DashboardPush: React.FC = () => {
  const initialFilters = useMemo(getInitialFilters, []);

  const [filters, setFilters] = useState<FilterState>(initialFilters);

  const [selectedHistory, setSelectedHistory] =
    useState<HistoricoDisparo | null>(null);

  const [isTemplateOpen, setIsTemplateOpen] = useState(false);
  //   const buildPayload = (state: FilterState) => {
  //   const payload: Record<string, number | string> = {
  //     tipo: state.type,

  //     mes: Number(state.month),

  //     ano: Number(state.year),
  //   };
  //   const defaultPayloadDate = moment()
  //     .set({
  //       date: state.dueOrClosingDay,
  //       month: state.month - 1,
  //       year: state.year,
  //     })
  //     .format('YYYY-MM-DD');
  //   console.log('STATE', state);
  //   // const hasSelectedADate = state.dueOrClosingDay !== null;

  //   // if (state.type === FormTypes.FECHAMENTO && hasSelectedADate) {
  //   //   payload.dataFechamento = defaultPayloadDate;
  //   // }

  //   // if (state.type === FormTypes.REGUA_COBRANCA && hasSelectedADate) {
  //   //   payload.dataVencimento = defaultPayloadDate;
  //   // }
  //   // if (state.type === FormTypes.COMUNICACAO) {
  //   //   payload.titulo = state.campaign;
  //   // }

  //   return payload;
  // };
  const buildPayload = (state?: FilterState) => {
    if (!state) state = filters;
    const payload: Record<string, number | string> = {
      tipo: state.type,

      mes: Number(state.month),

      ano: Number(state.year),
    };

    console.log('STATE', state);
    const hasSelectedADate = state.dueOrClosingDay !== null;

    const defaultPayloadDate = moment()
      .set({
        date: state.dueOrClosingDay,
        month: state.month - 1,
        year: state.year,
      })
      .format('YYYY-MM-DD');
    if (state.type === FormTypes.REGUA_COBRANCA && hasSelectedADate) {
      payload.dataVencimento = defaultPayloadDate;
    }
    if (state.type === FormTypes.FECHAMENTO && hasSelectedADate) {
      payload.dataFechamento = defaultPayloadDate;
    }
    return payload;
  };

  const {
    callApi,
    data: pushData,
    loading,
    error,
  } = useApi<PushDashboardResponse>({
    url: Endpoints.graphc.getPushNotificationsDashboard,

    method: ApiMethod.GET,

    fetchOnMount: false,

    tryNewWay: true,
  });
  const currentResumeObject = useMemo<HistoricoDisparo | null>(() => {
    if (!pushData?.historicoDisparos?.length) {
      return null;
    }

    if (filters.type === FormTypes.REGUA_COBRANCA) {
      return pushData.historicoDisparos[0];
    }

    if (filters.type === FormTypes.COMUNICACAO) {
      return (
        pushData.historicoDisparos.find(
          (item) => item.title === filters.campaign,
        ) || pushData.historicoDisparos[0]
      );
    }

    return (
      pushData.historicoDisparos.find(
        (item) => String(item.dia) === String(filters.dueOrClosingDay),
      ) || pushData.historicoDisparos[0]
    );
  }, [
    filters.campaign,
    filters.dueOrClosingDay,
    filters.type,
    pushData?.historicoDisparos,
  ]);
  console.log('FILTERs', filters);
  console.log('CURRENT FILTER', currentResumeObject);
  const resumoUltimoRegistro = {
    totalClientes: currentResumeObject?.totalClientes || 0,
    pushEnviadas: currentResumeObject?.pushEnviadas || 0,
    pushPendentes: currentResumeObject?.pushPendentes || 0,
    percentualEnviadas:
      (currentResumeObject?.totalClientes ?? 0) > 0
        ? Math.round(
            ((currentResumeObject?.pushEnviadas ?? 0) /
              currentResumeObject.totalClientes) *
              10000,
          ) / 100
        : 0,
    status: currentResumeObject?.status,
  };
  const {
    data: topics = [],
    loading: loadingTopics,
    refetch: refetchTopics,
  } = useApi<TopicsResponse[]>({
    url: Endpoints.graphc.getPushNotificationsTopics,
    method: ApiMethod.GET,
    fetchOnMount: true,
    tryNewWay: true,
    body: {
      tipo: 'COMUNICACAO',
    },
  });
  const historyRows = useMemo(() => {
    if (!pushData?.historicoDisparos) {
      return [];
    }

    return [...pushData.historicoDisparos].sort((a, b) =>
      moment(b.createdAt).diff(moment(a.createdAt)),
    );
  }, [pushData?.historicoDisparos]);

  const summary = pushData?.resumoDiaAtual;

  const percentSeries = resumoUltimoRegistro?.percentualEnviadas;

  const campaignOptions = useMemo(() => {
    if (!topics?.length) {
      return [];
    }

    return topics;
  }, [topics]);

  const lastUpdateDate = useMemo(() => {
    const reference =
      historyRows[0]?.completedAt ||
      historyRows[0]?.createdAt ||
      summary?.completedAt;

    if (!reference) {
      return moment().format('DD/MM/YYYY HH:mm');
    }

    return moment(reference).format('DD/MM/YYYY HH:mm');
  }, [historyRows, summary?.completedAt]);

  const selectedMonthLabel = useMemo(
    () => MONTH_OPTIONS.find((month) => month.id === filters.month)?.value,

    [filters.month],
  );

  const handleSelectType = (type: FormTypes) => {
    const nextFilters = {
      ...filters,
      type,
      dueOrClosingDay: getDefaultDueOrClosingDay(type),
      campaign: type === FormTypes.COMUNICACAO ? filters.campaign : '',
    };

    setFilters(nextFilters);
    loadDashboard(nextFilters);
  };

  const handleTemplateOpen = (item: HistoricoDisparo) => {
    setSelectedHistory(item);

    setIsTemplateOpen(true);
  };

  const handleCloseTemplate = () => {
    setIsTemplateOpen(false);

    setSelectedHistory(null);
  };

  const getRowTitle = (row: HistoricoDisparo) => {
    if (filters.type === FormTypes.COMUNICACAO) {
      return row.title;
    }
    if (filters.type === FormTypes.FECHAMENTO) {
      return `Dia ${row.dia}`;
    }
    return row.dia;
  };

  const formatStatus = (status?: string) => {
    if (!status) {
      return 'Em atualização';
    }

    const trimmed = status.trim().toLowerCase();

    if (trimmed.includes('processando')) {
      return 'Processando';
    }

    if (trimmed.includes('finalizada')) {
      return 'Finalizada';
    }

    return status;
  };

  const getStatusColor = (status?: string) => {
    const normalized = status?.toLowerCase() ?? '';

    if (normalized.includes('finalizada')) {
      return '#2c9d3f';
    }

    if (normalized.includes('processando')) {
      return '#e5a22b';
    }

    return '#6c757d';
  };

  const corteDateLabel = moment(pushData?.dataCorte).format('DD/MM/YYYY');

  const vencimentoLabel = moment(pushData?.dataVencimento).format('DD/MM/YYYY');
  const loadTopics = useCallback(
    async (state: FilterState) => {
      const body = {
        mes: state.month,
        ano: state.year,
        tipo: 'COMUNICACAO',
      };
      const topicsResponse = await refetchTopics(body);
      return topicsResponse;
    },
    [refetchTopics],
  );

  const loadDashboard = useCallback(
    async (state: FilterState = filters) => {
      const response = await callApi(buildPayload(state));
      const ultimoRegistro = response?.data?.historicoDisparos?.[0];

      if (state?.type === FormTypes.COMUNICACAO && ultimoRegistro?.title) {
        await loadTopics(state);

        if (state.campaign !== ultimoRegistro.title) {
          setFilters((prev) => ({
            ...prev,
            campaign: ultimoRegistro.title,
          }));
        }
      }
    },
    [callApi, filters, loadTopics],
  );

  const onChangeDateOrCampaignFilter = async (event: Event) => {
    const value = event?.target?.value;
    console.log('onChangeDateOrCampaignFilter', value);
    const key =
      filters.type === FormTypes.COMUNICACAO ? 'campaign' : 'dueOrClosingDay';
    const nextFilters = {
      ...filters,
      [key]: key === 'dueOrClosingDay' ? Number(value) : value,
    };

    setFilters((prev) => ({
      ...prev,
      [key]: key === 'dueOrClosingDay' ? Number(value) : value,
    }));

    if (nextFilters.type !== FormTypes.COMUNICACAO) {
      await loadDashboard(nextFilters);
    }
  };

  useEffect(() => {
    loadDashboard(initialFilters);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Loading status={loading} />

      <Dialog
        open={isTemplateOpen}
        positiveLabel="Voltar"
        positiveAction={handleCloseTemplate}
      >
        <S.TemplateContent>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              padding: '16px',
              backgroundColor: '#E9ECEF',
              borderRadius: 16,
              marginTop: 8,
            }}
          >
            <span
              style={{
                borderBottom: '1px solid black',
                textAlign: 'center',
                fontWeight: 700,
                marginBottom: 16,
              }}
            >
              Template da push
            </span>
            <b style={{ marginTop: 4, fontSize: 18 }}>
              {selectedHistory?.title}
            </b>
            <p style={{ fontSize: 16 }}>{selectedHistory?.description}</p>
          </div>
        </S.TemplateContent>
      </Dialog>

      <Container title="Dashboard Push">
        <ContainerFlex width={100} row space>
          <div>
            <S.Title>Acompanhamento dos disparos Push</S.Title>

            <S.Subtitle>
              {`Referente ao mês de ${
                selectedMonthLabel || ''
              }. última atualização: ${lastUpdateDate}`}
            </S.Subtitle>
          </div>

          <S.ActionBlock>
            <S.UpdateButton type="button" onClick={() => loadDashboard(null)}>
              <MdOutlineRefresh />
              Atualizar
            </S.UpdateButton>
          </S.ActionBlock>
        </ContainerFlex>
        <ContainerFlex width={100} row space horizontal center>
          <ContainerFlex>
            <S.TypeSwitcher row>
              {REPORT_PUSH_OPTIONS.map((option) => (
                <S.TypeButton
                  key={option.id}
                  type="button"
                  active={filters.type === option.id}
                  onClick={() => handleSelectType(option.id)}
                >
                  {option.value}
                </S.TypeButton>
              ))}
            </S.TypeSwitcher>
          </ContainerFlex>
          <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
            <div style={{ width: '220px' }}>
              <SelectDate
                showDay={false}
                years={YEAR_OPTIONS}
                days={[]}
                months={MONTH_OPTIONS}
                value={filters.month}
                valueYear={filters.year}
                onChange={(v) => setFilters((prev) => ({ ...prev, month: v }))}
                onChangeYears={(v) =>
                  setFilters((prev) => ({ ...prev, year: v }))
                }
                onSearch={loadDashboard}
              />
            </div>
          </div>
        </ContainerFlex>

        {filters.type !== FormTypes.COMUNICACAO ? (
          <S.InfoRow>
            <span>{`Data de corte: ${corteDateLabel}`}</span>

            <span>{`Data de vencimento: ${vencimentoLabel}`}</span>
          </S.InfoRow>
        ) : null}

        <S.SummarySection>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <S.Filters>
              {filters.type !== FormTypes.COMUNICACAO && (
                <S.FilterGroup>
                  <S.FilterLabel>
                    {filters.type === FormTypes.FECHAMENTO
                      ? 'Dia de fechamento'
                      : 'Dia de vencimento'}
                  </S.FilterLabel>

                  <S.FilterSelect
                    value={filters.dueOrClosingDay}
                    onChange={(event) => {
                      onChangeDateOrCampaignFilter(event);
                    }}
                  >
                    {[
                      ...(filters.type === FormTypes.FECHAMENTO
                        ? CLOSING_DAY_OPTIONS
                        : DUE_DAY_OPTIONS),
                    ].map((day) => (
                      <option key={day} value={day}>
                        {day}
                      </option>
                    ))}
                  </S.FilterSelect>
                </S.FilterGroup>
              )}

              {filters.type === FormTypes.COMUNICACAO && (
                <S.FilterGroup>
                  <S.FilterLabel>Campanha</S.FilterLabel>

                  <S.FilterSelect
                    value={filters.campaign}
                    onChange={(event) => {
                      onChangeDateOrCampaignFilter(event);
                    }}
                    disabled={!campaignOptions.length}
                  >
                    {!campaignOptions.length && (
                      <option value="">Nenhuma campanha encontrada</option>
                    )}

                    {campaignOptions.map((campaign) => (
                      <option key={campaign.id} value={campaign.title}>
                        {campaign.title}
                      </option>
                    ))}
                  </S.FilterSelect>
                </S.FilterGroup>
              )}
            </S.Filters>
            <S.SectionTitle style={{ marginBottom: 2, marginTop: 8 }}>
              {!currentResumeObject
                ? 'Sem dados para o filtro selecionado'
                : filters.type === FormTypes.COMUNICACAO
                ? `Resumo da campanha ${currentResumeObject?.title}`
                : `Resumo do dia ${currentResumeObject?.dia}`}
            </S.SectionTitle>
          </div>

          <div
            style={{ display: 'flex', flexDirection: 'row', marginRight: 8 }}
          >
            <S.ChartCard>
              <Chart
                options={{
                  chart: {
                    type: 'radialBar',
                  },
                  colors: ['#e4003a'],
                  plotOptions: {
                    radialBar: {
                      hollow: {
                        size: '70%',
                      },
                      dataLabels: {
                        name: {
                          show: false,
                        },
                        value: {
                          fontWeight: 700,
                          fontSize: '28px',
                          show: true,
                        },
                        total: {
                          show: false,
                        },
                      },
                    },
                  },
                  stroke: {
                    lineCap: 'round',
                  },
                  fill: {
                    type: 'gradient',
                    gradient: {
                      shade: 'dark',
                      type: 'horizontal',
                      gradientToColors: ['#db6826'],
                      stops: [0, 100],
                    },
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  legend: {
                    show: false,
                  },
                }}
                series={[percentSeries]}
                type="radialBar"
                height={230}
              />

              <S.ChartCaption>
                <span>% das pushs enviadas</span>
              </S.ChartCaption>
            </S.ChartCard>

            <S.MetricGrid>
              <S.MetricCard>
                <span>Total de clientes</span>

                <strong>
                  {formatNumber(resumoUltimoRegistro?.totalClientes)}
                </strong>
              </S.MetricCard>

              <S.MetricCard>
                <span>Pushs enviadas</span>

                <strong>
                  {formatNumber(resumoUltimoRegistro?.pushEnviadas)}
                </strong>
              </S.MetricCard>

              <S.MetricCard>
                <span>Pushs pendentes</span>

                <strong>
                  {formatNumber(resumoUltimoRegistro?.pushPendentes)}
                </strong>
              </S.MetricCard>

              <S.MetricCard>
                <span>Status</span>

                <S.StatusBadge
                  color={getStatusColor(resumoUltimoRegistro?.status)}
                >
                  {formatStatus(resumoUltimoRegistro?.status)}
                </S.StatusBadge>
              </S.MetricCard>
            </S.MetricGrid>
          </div>
        </S.SummarySection>

        {error && (
          <S.ErrorState>
            <p>Não foi possível carregar os dados. Tente novamente.</p>

            <S.UpdateButton type="button" onClick={loadDashboard}>
              <MdOutlineRefresh />
              Recarregar
            </S.UpdateButton>
          </S.ErrorState>
        )}

        <S.HistorySection>
          <S.SectionTitle>Histórico de disparos</S.SectionTitle>

          {historyRows.length > 0 ? (
            <S.HistoryTable>
              <thead>
                <tr>
                  <S.HistoryHeaderCell>Dia / Campanha</S.HistoryHeaderCell>

                  <S.HistoryHeaderCell>Total de clientes</S.HistoryHeaderCell>

                  <S.HistoryHeaderCell>Pushs enviadas</S.HistoryHeaderCell>

                  <S.HistoryHeaderCell>Pushs pendentes</S.HistoryHeaderCell>
                  <S.HistoryHeaderCell>Status</S.HistoryHeaderCell>
                </tr>
              </thead>

              <tbody>
                {historyRows.map((row) => (
                  <S.HistoryRow
                    key={row.id}
                    onClick={() => handleTemplateOpen(row)}
                  >
                    <S.HistoryCell>
                      <strong>{getRowTitle(row)}</strong>
                    </S.HistoryCell>

                    <S.HistoryCell>
                      {formatNumber(row.totalClientes)}
                    </S.HistoryCell>

                    <S.HistoryCell>
                      {formatNumber(row.pushEnviadas)}
                    </S.HistoryCell>

                    <S.HistoryCell>
                      {formatNumber(row.pushPendentes)}
                    </S.HistoryCell>

                    <S.HistoryCell>
                      <S.StatusBadge color={getStatusColor(row.status)}>
                        {formatStatus(row.status)}
                      </S.StatusBadge>
                    </S.HistoryCell>
                  </S.HistoryRow>
                ))}
              </tbody>
            </S.HistoryTable>
          ) : (
            !loading &&
            !error && (
              <S.EmptyState>
                Nenhum disparo encontrado para os filtros selecionados.
              </S.EmptyState>
            )
          )}
        </S.HistorySection>
      </Container>
    </>
  );
};

export default DashboardPush;
